"use client";

import { MapPin } from "lucide-react";
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
interface Location {
  id: number;
  city: string;
  note: string;
}
const locations: Location[] = [{
  id: 1,
  city: "Miami, Florida",
  note: "Based in Miami with mobile service throughout South Florida and surrounding areas"
}];
export default function OurLocations() {
  const [selectedLocation, setSelectedLocation] = useState<Location | null>(null);
  return <section className="relative bg-dark-background text-foreground-dark py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/aerial_city_texture.png)] bg-cover bg-center opacity-5 pointer-events-none" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-secondary/5 pointer-events-none" />

      <div className="relative z-10 container mx-auto px-6 max-w-6xl">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-center mb-6 tracking-tight">
          Our Service Area
        </h2>
        <p className="text-center text-muted-light text-lg md:text-xl mb-16 max-w-3xl mx-auto leading-relaxed">
          We bring our expertise directly to you. Based in Miami, Florida, we provide mobile plumbing services throughout the region, ensuring fast and reliable support wherever you need us.
        </p>

        <div className="grid gap-6 md:grid-cols-2 max-w-4xl mx-auto">
          {locations.map((location, i) => <Button key={location.id} data-index={i} onClick={() => setSelectedLocation(location)} variant="ghost" size="lg" className="flex items-start gap-6 p-8 rounded-xl bg-background/10 backdrop-blur-sm border-2 border-border/20 shadow-soft transition-all duration-300 ease-[var(--ease-out-back)] hover:-translate-y-2 hover:shadow-strong hover:bg-background/20 hover:border-primary/30 focus:outline-none focus:ring-2 focus:ring-primary/50 text-left h-auto justify-start group">
              <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-gradient-to-br from-accent/30 to-accent/10 flex items-center justify-center shadow-soft transition-all duration-300 group-hover:scale-110 group-hover:shadow-medium">
                <MapPin className="w-7 h-7 text-accent-dark" />
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-display font-bold mb-2 text-foreground-dark group-hover:text-primary transition-colors duration-300">
                  {location.city}
                </h3>
                <p className="text-sm text-foreground leading-relaxed">
                  {location.note}
                </p>
              </div>
            </Button>)}
        </div>
      </div>

      {}
      <Dialog open={!!selectedLocation} onOpenChange={open => !open && setSelectedLocation(null)}>
        <DialogContent className="sm:max-w-3xl bg-background/95 backdrop-blur-lg border-border/60 shadow-strong">
          <DialogHeader>
            <DialogTitle className="text-3xl font-display font-bold text-foreground mb-2">
              {selectedLocation?.city}
            </DialogTitle>
            <DialogDescription className="text-muted text-base">
              {selectedLocation?.note}
            </DialogDescription>
          </DialogHeader>
          <div className="mt-6">
            <div className="w-full h-96 bg-muted/50 rounded-xl flex items-center justify-center border-2 border-border/40 shadow-soft">
              <div className="text-center text-muted-foreground">
                <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                  <MapPin className="w-8 h-8 text-primary" />
                </div>
                <p className="text-base font-semibold mb-2">Mobile Service Coverage</p>
                <p className="text-sm">We come to your location throughout South Florida</p>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </section>;
}